import React from "react";
import _ from 'lodash';

import { 
    Row,
    Col,
    Form,
    Spinner,
    Button,
} from "react-bootstrap-v5";

import { DrawerContentLayout } from '../../../components/drawer/DrawerLayout'
import Utils from "../../../utils/utils";

import RSuiteSelectPicker from '../../../components/OLD/Select/RSuiteSelectPicker';
import makeWasteTypeCategory from "../../../components/makeCategoryCompenents/wasteTypeCategory/makeWasteTypeCategory";

import { connect } from 'react-redux'
import { clear } from "../../../../setup/redux/actions";
import { dispatchApiCallGet } from '../../../../setup/redux/dispatch/actions'


const WasteTypeCategory = makeWasteTypeCategory(RSuiteSelectPicker);


class WasteTypesForm extends React.Component {
  
    constructor(props) {
        super(props);
    
        this.bodyRef = React.createRef();

        let dataParams = (props.dataParams) ? props.dataParams : null;
        let id = (dataParams && dataParams.id) ? dataParams.id : null;
        let row = (dataParams && dataParams.row) ? dataParams.row : null;
        
        this.state = {
            id: id,
            row: row,
        };
    }


    componentWillReceiveProps(nextProps) {
        this.reduxProps(nextProps);
    }


    /* API */
    reduxProps = nextProps => {
        Utils.reduxProps(nextProps,
            'wastetype_form_drawer-waste_type_category', 
            (data, isLoading, isError, err, statusCode, variables, callback) => {
                let arr = variables.items;

                if(data && data.data && data.data.length > 0) {
                    for (var i = 0; i < data.data.length; i++) {
                        let item = data.data[i];
                        let value = item.wasteTypeCategoryId;
                        let title = item.wasteTypeCategoryName;
                        let arrItem = {
                            value: value,
                            title: title,
                            item: item,
                        };

                        arr = Utils.addToArray(arr, value, arrItem);
                    }
                }

                this.setState({
                    isLoading: isLoading,
                    isError: isError,
                    err: err,
                }, () => {
                    this.props.clear();

                    if(callback){
                        callback(arr);
                    }
                });
            }
        );
    }
	
    callReadCategoryApi = (items, callback = null) => {
        let data = {
            currentPage: 1,
            pageSize: Utils.getMaxPageSize(),
            searchQuery: '',
        };
     
        this.props.dispatchApiCallGet(data, 'wastetype_form_drawer-waste_type_category', 'WasteTypeCategory', { items: items }, callback, () => {});
    }
    /* END API */


    body = () => {
        let {
            handleChange,
            setFieldValue,
            validateForm,
            values,
            errors,
        } = this.props.formOptions;
        
        return <Row>
            
            <Col xs={12}>
                <Form.Group className={'mb-5'}>
                    <Form.Label>{this.props.fields.wasteTypeName.label}</Form.Label>
                    <Form.Control
                        type="text"
                        id={this.props.fields.wasteTypeName.id}
                        placeholder={this.props.fields.wasteTypeName.placeholder}
                        maxLength={this.props.fields.wasteTypeName.maxLength}
                        value={values.wasteTypeName}
                        onChange={handleChange}
                        isInvalid={!!errors.wasteTypeName}
                    />
                    <Form.Control.Feedback type="invalid">{errors.wasteTypeName}</Form.Control.Feedback>
                </Form.Group>
            </Col>
            <Col xs={12}>
                <Form.Group className={'mb-5'}>
                    <Form.Label>{this.props.fields.categoryId.label}</Form.Label>
                    <Form.Control
                        as = {WasteTypeCategory}
                        isInvalid={!!errors.categoryId}

                        id={this.props.fields.categoryId.id}
                        placeholder={this.props.fields.categoryId.placeholder}
                        items={values.customFormParams.categoryItems}
                        value={values.categoryId}
                        selectedName={values.categoryName}
                        isLoading={values.customFormParams.categoryIsLoading}
                        searchable={true}
                        cleanable={true}
                        isDefault={true}
                        onClick={async () => {
                            await setFieldValue('customFormParams.categoryIsLoading', true);
                            this.callReadCategoryApi(values.customFormParams.categoryItems, async (items) => {
                                await setFieldValue('customFormParams.categoryItems', items);
                                await setFieldValue('customFormParams.categoryIsLoading', false);
                            });
                        }}
                        onSelect={async (value, item) => {
                            await setFieldValue('categoryId', value);
                            await setFieldValue('categoryName', item.title);
                        }}
                        onClear={async () => {
                            await setFieldValue('categoryId', null);
                            await setFieldValue('categoryName', '');
                        }}
                        onCreate={async (item) => {
                            let items = values.customFormParams.categoryItems;
                            items.push(item)
                            await setFieldValue('customFormParams.categoryItems', items);
                            await setFieldValue('categoryId', item.value);
                            await setFieldValue('categoryName', item.title);
                        }}
                        onUpdate={async (item) => {
                            let items = values.customFormParams.categoryItems
                            let index = items.findIndex(x => x.value === item.value);
                            items[index] = item;

                            await setFieldValue('customFormParams.categoryItems', items);
                            if(values.categoryId === item.value){
                                await setFieldValue('categoryId', item.value);
                                await setFieldValue('categoryName', item.title);
                            }
                        }}
                        onRemove={async (item) => {
                            let items = values.customFormParams.categoryItems.filter(x => x.value !== item.value);
                            await setFieldValue('customFormParams.categoryItems', items);
                            await setFieldValue('categoryId', null);
                            await setFieldValue('categoryName', '');
                        }}
                    />
                    <Form.Control.Feedback type="invalid">{errors.categoryId}</Form.Control.Feedback>
                </Form.Group>
            </Col>

        </Row>
    }
    
    footer = () => {
        let {
            validateForm,
            values,
        } = this.props.formOptions;

        return <Row>
            <Col xs={'auto'}>
                <Button 
                    type={'submit'}
                    disabled={this.props.isLoading}
                >
                    SAVE
                    {this.props.isLoading ? <>&nbsp;<Spinner animation="border" size={'sm'} /></> : null}
                </Button>
            </Col>
            <Col xs={'auto'}>
                <Button 
                    type={'button'}
                    variant={'secondary'}
                    disabled={this.props.isLoading}
                    onClick={() => {
                        Utils.showDrawer(this.props.drawer, false);
                    }}
                >
                    CANCEL
                    {this.props.isLoading ? <>&nbsp;<Spinner animation="border" size={'sm'} /></> : null}
                </Button>
            </Col>
            
            
            {values.isEdit && <>
                <Col xs={12} className={'d-flex d-sm-none pb-3'}></Col>
                <Col xs={'auto'} sm={true} className={'text-end'}>
                    <Button 
                        type={'button'}
                        variant={'danger'}
                        disabled={this.props.isLoading}
                        onClick={() => {
                            if(this.props.onDelete){
                                this.props.onDelete(values);
                            }
                        }}
                    >
                        REMOVE
                        {this.props.isLoading ? <>&nbsp;<Spinner animation="border" size={'sm'} /></> : null}
                    </Button>
                </Col>
                <Col xs={'auto'} md={'auto'}>
                    <Button 
                        type={'button'}
                        variant={'outline-secondary'}
                        disabled={this.props.isLoading}
                        onClick={() => {
                            validateForm().then((err) => {
                                if(_.isEmpty(err)){
                                    if(this.props.onCopy){
                                        this.props.onCopy(values);
                                    }
                                } else {
                                    Utils.toast('You must fill in the required fields', 'error');
                                }
                            })
                        }}
                    >
                        <i className={'material-icons'}>content_copy</i>
                        COPY
                        {this.props.isLoading ? <>&nbsp;<Spinner animation="border" size={'sm'} /></> : null}
                    </Button>
                </Col>
            </>}

        </Row>
    }


    render() {
        return <DrawerContentLayout
            ref={this.bodyRef}
            isBlocking={this.props.isBlocking}
            body={this.body()}
            footer={this.footer()}
        />
    }
}

const mapDispatchToProps = {
  dispatchApiCallGet,
  clear,
}

export default connect(Utils.mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(WasteTypesForm);
